import axios from "axios";
const API_KEY = "09ff7a90385b4d8fa750c437958ca31c";

export async function getGeoLocation() {
  const response = await axios.get(
    `https://api.ipgeolocation.io/ipgeo?apiKey=${API_KEY}`
  );
  return response;
}

// export async function getAstronomicalData(city) {
//   const response = await axios.get(
//     `https://api.ipgeolocation.io/astronomy?apiKey=${API_KEY}&location=${city}`
//   );
//   return response;
// }

export async function getAstronomicalData(city) {
  try {
    const response = await axios.get(
      `https://api.ipgeolocation.io/astronomy?apiKey=${API_KEY}&location=${city}`,
      {}
    );
    return response;
  } catch (error) {
    getAstronomicalData("dhaka");
  }
}
